import { FiMoreVertical } from "react-icons/fi";
import { v4 as uuid } from "uuid";
import { Button } from "../../../../UI";
import { Link } from "react-router-dom";
import { AdminOrders } from "../../../../store/actions";
import moment from "moment";

export const columns = ({ handleDisplayMenu, showDisplay }) => [
  {
    title: "Tracking Number",
    field: "trackingNumber",
    render: (row) => <div>{row.trackingNumber || row.tracking_number || 'N/A'}</div>
  },
  {
    title: "Customer",
    render: (row) => <div>{row.customerName || row.customer_name || 'N/A'}</div>
  },
  {
    title: "Pickup Address",
    render: (row) => <div style={{ maxWidth: '200px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
      {row.pickupAddress || row.pickup_address || 'N/A'}
    </div>
  },
  {
    title: "Delivery Address",
    render: (row) => <div style={{ maxWidth: '200px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
      {row.deliveryAddress || row.delivery_address || 'N/A'}
    </div>
  },
  {
    title: "Date",
    render: (row) => <div>{moment(row.createdAt || row.created_at).format("MMM Do YY")}</div>
  },
  {
    title: "Delivery Fee",
    render: (row) => <div>₦{row.deliveryFee || row.delivery_fee || 0}</div>
  },
  {
    title: "Status",
    render: (row) => {
      const status = (row.status || '').toUpperCase();
      const getStatusColor = () => {
        switch(status) {
          case 'PENDING': return '#FFA500';
          case 'ASSIGNED': return '#2196F3';
          case 'PICKED_UP': return '#9C27B0';
          case 'IN_TRANSIT': return '#FF9800';
          case 'DELIVERED': return '#4CAF50';
          case 'CANCELLED': return '#F44336';
          default: return '#757575';
        }
      };
      return (
        <div style={{ 
          color: getStatusColor(),
          fontWeight: '600',
          textTransform: 'capitalize'
        }}>
          {status.replace(/_/g, ' ')}
        </div>
      );
    }
  },
  {
    title: "Action",
    align: "center",
    render: (row) => (
      <div className="popup__container">
        <Button
          icon
          arial-label="show menu"
          className="btn--showMore"
          onClick={(e) => {
            handleDisplayMenu(row.id);
          }}
        >
          <FiMoreVertical style={{ pointerEvents: "none" }} />
        </Button>
        {showDisplay === row.id && (
          <div className="action--container">
           <Link to="/dashboard/orders/rider" state={row}>
              <Button full tertiary>
                Assign Rider
              </Button>
            </Link>
            <Link to={`/dashboard/orders/${row.id}/details`} state={row}>
              <Button full tertiary style={{color:"yellow"}}>
                Edit
              </Button>
            </Link>
            <Link to="/dashboard/orders/OrderDetails" state={row}>
              <Button full tertiary style={{color:"green"}}>
                View
              </Button>
            </Link>
          </div>
        )}
      </div>
    )
  }
];

export const data = [...Array(10).keys()].map(() => ({
  order_no: "# PO1608055878778",
  id: uuid(),
  weight: 12,
  priority: "Low",
  date: "13 Jan 2020",
  amount: "N50,000",
  status: "pending"
}));
